import { Component } from '@angular/core';
import { SessionService } from 'src/app/features/shared/services/Session.service';

@Component({
  selector: 'user-logsPage',
  templateUrl: './user-logsPage.component.html',
  styleUrls: ['./user-logsPage.component.css']
})
export class UserLogsPageComponent {

  constructor(private sessionService: SessionService) { }
  
    ngOnInit(): void {
      this.sessionService.setIsExternalMap(false);
    }
  
}
